module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a998ad61ffc51ecd25cad7ef43a2d9f5.png";